export  {}

export type DIR = 'up' | 'right' | 'down' | 'left';

export const CACHE_MAP_KEY = "mapInput";
export const CACHE_MAP_COLOR_KEY = "selectedColor";
export const CACHE_MAP_SECONDARY_COLOR_KEY = "secondaryColor";
export const CACHE_SWITCH_MUL_COLOR = "switchMulColor";
export const CACHE_MAP_TILES_KEY = "mapTilesList";
export const CACHE_MAP_USER_INFO_KEY = "userInfo";
